<div class="details-text">
  <p class="fs-6 mb-0">
    Speed: <i>{{speed}} km/h</i> |
    Heading: <i>{{heading}}&deg;</i> |
    Altitude: <i>{{altitude}} m</i>
  </p>
</div>

@for (key of (temporalMetaData | keyvalue); track key) {
  <div>
    <p>{{ key.key }}: <i>{{ key.value }}</i></p>
  </div>
}

@for (key of getMetaDataKeys(); track key) {
  <div>
    <p>{{ key }}: <i>{{ getMetaDataValue(key) }}</i></p>
  </div>
}